import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { getManualTranslation } from '../i18n';
import { apiList, getCancelData } from '../api/callAPI';
import useUser from '../hook/useUser';
import useCancel from '../hook/useCancel';
import * as urlConstants from '../constants/url';
import * as alertConstants from '../constants/alertMsg';
import _ from 'lodash'
import axios from 'axios';

//facebook fields definition
const useFieldsData = () => {
  const history = useHistory();
  const intl = useIntl();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const [isLoading, setIsLoading] = useState(true);
  const [fieldsData, setFieldsData] = useState([]);
  const { cancelData, setCancelData } = useCancel();
  const [isLoadingData, setIsLoadingData] = useState(false);

  const fetchColumnDefinition = () => {
    if (history.location.pathname.includes("line") || history.location.pathname.includes("google")) return;

    let fieldsDefined;

    fieldsDefined = apiList.columnDefinition({})

      .then(res => {
        if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;

        if (res.status === 200) {
          // console.log('columnDefinition',res);
          setFieldsData(res.data);
          setIsLoading(false);
        } else if (res.status === 401) {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else {
          setAlertMsg(alertConstants.ERROR_SYSTEMCONNECT);
        }
      })
  }

  useEffect(() => {
    fetchColumnDefinition();
  }, [])

  // console.log('fieldsData',fieldsData);

  //排序欄位
  const columnSort = fieldsData.sort((a, b) => {
    return a.categoryIndex - b.categoryIndex;
  });

  //自定義指標欄位
  const initializeCustomFields = [
    {
      category: 'custom',
      name: 'custom',
      child: []
    }
  ]

  // 自選欄位"required": false
  const filterOptionalFields = Array.from(new Set(columnSort
    .filter((el) => el.categoryName !== "固定欄位" && el.categoryName !== 'important')
    .map((s) => s.categoryId))).map(
      (lab, index) => {
        return {
          category: `${lab}_${index}`,
          name: lab,
          child: columnSort
            .filter((s) => s.categoryId === lab && s.required === false)
            .map((edition) => {
              return {
                name: edition.name,
                expression: edition.id,
                format: edition.format,
                type: edition.type,
                indexNumber: edition.indexNumber,
              };
            })
        };
      }
    );

  //自定義指標 + 自選欄位
  // const optionalFields = initializeCustomFields.concat(filterOptionalFields);
  const optionalFields = filterOptionalFields;

  //必選欄位"required": true 且 "isDimension": false
  const requiredMetricsFields = Array.from(
    new Set(
      columnSort.filter(
        (el) => el.required === true && el.isDimension === false
      ).map((s) => (s.categoryName = "important"))
    )
  ).map((label, index) => {
    return {
      category: `${label}_${index}`,
      name: label,
      child: columnSort.filter((s) => s.categoryName === label).map(
        (edition) => {
          return {
            name: edition.name,
            name_en: getManualTranslation(`facebook.field.${edition.id}`, 'ENGLISH'),
            name_ja: getManualTranslation(`facebook.field.${edition.id}`, 'JAPANESE'),
            expression: edition.id,
            format: edition.format,
            type: edition.type,
            indexNumber: edition.indexNumber,
          };
        }
      )
    };
  });

  //必選欄位"required": true 且 "hidden === false"
  const updateRequiredFields = Array.from(
    new Set(columnSort.filter((el) => el.required === true && el.hidden === false))
    // new Set(columnSort.filter((el) => el.required === true && el.categoryName !== "固定欄位"))
  ).map((item, index) => {
    return {
      name: item.name,
      expression: item.id,
      format: item.format,
      type: item.type,
      indexNumber: item.indexNumber,
    };
  }
  )

  return [optionalFields, requiredMetricsFields, updateRequiredFields];

};

export default useFieldsData;